import { Fragment } from "react";
import { Link } from "react-router-dom";

const TOKEN = /(\[[^\]]+\]\([^)\s]+\)|\*\*[^*]+\*\*)/g;

// Renders **bold** and [label](/path) without injecting HTML
export const renderInline = (text) =>
  text.split(TOKEN).map((part, i) => {
    const link = part.match(/^\[([^\]]+)\]\(([^)\s]+)\)$/);
    if (link) {
      const [, label, href] = link;
      const cls = "text-[#59394F] underline underline-offset-4 decoration-[#C99898] hover:text-[#432A3B]";
      return href.startsWith("/")
        ? <Link key={i} to={href} className={cls}>{label}</Link>
        : <a key={i} href={href} target="_blank" rel="noopener noreferrer" className={cls}>{label}</a>;
    }
    const bold = part.match(/^\*\*([^*]+)\*\*$/);
    if (bold) return <strong key={i}>{bold[1]}</strong>;
    return <Fragment key={i}>{part}</Fragment>;
  });

// Splits FAQ markdown ("**Q: question** answer", blocks separated by blank lines)
export const parseFaq = (md) =>
  md.split(/\n\s*\n(?=\*\*Q:)/).map((block) => {
    const m = block.trim().match(/^\*\*Q:\s*([\s\S]+?)\*\*\s*([\s\S]*)$/);
    if (!m) return null;
    return { q: m[1].trim(), a: m[2].split(/\n+/).map((s) => s.trim()).filter(Boolean) };
  }).filter(Boolean);
